import { useState, useEffect, useCallback } from 'react';

type Theme = 'light' | 'dark';

const THEME_KEY = 'portfolio-theme';

const lightTheme = {
  bg: '#FEFEFE',
  bgSecondary: '#F6F6F7',
  bgElevated: '#FFFFFF',
  text: '#111111',
  textSecondary: '#6E6E73',
  textMuted: '#AEAEB2',
  border: 'rgba(0,0,0,0.06)',
  borderStrong: 'rgba(0,0,0,0.12)',
  accent: '#1D1D1F',
  accentInverse: '#FEFEFE',
  headerBg: 'rgba(245,245,244,0.7)',
  radiusSmall: '10px',
  radiusMedium: '14px',
  radiusLarge: '20px',
  fontDisplay: "'DM Serif Display', Georgia, serif",
  fontBody: "'Instrument Sans', -apple-system, sans-serif",
};

const darkTheme = {
  bg: '#1A1A1C',
  bgSecondary: '#2A2A2E',
  bgElevated: '#2C2C30',
  text: '#FAFAFA',
  textSecondary: '#A1A1AA',
  textMuted: '#6E6E73',
  border: 'rgba(255,255,255,0.08)',
  borderStrong: 'rgba(255,255,255,0.14)',
  accent: '#FAFAFA',
  accentInverse: '#1A1A1C',
  headerBg: 'rgba(26,26,28,0.7)',
  radiusSmall: '10px',
  radiusMedium: '14px',
  radiusLarge: '20px',
  fontDisplay: "'DM Serif Display', Georgia, serif",
  fontBody: "'Instrument Sans', -apple-system, sans-serif",
};

export type ThemeColors = typeof lightTheme;

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(() => {
    try {
      const saved = localStorage.getItem(THEME_KEY);
      if (saved === 'light' || saved === 'dark') return saved;
    } catch {}
    const tg = (window as any).Telegram?.WebApp;
    if (tg?.colorScheme) return tg.colorScheme;
    return 'light';
  });

  const colors = theme === 'dark' ? darkTheme : lightTheme;

  useEffect(() => {
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {}
  }, [theme, colors]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  }, []);

  return { theme, colors, toggleTheme };
};
